// extracted by mini-css-extract-plugin
export default {"reveal":"reveal-on-scroll_reveal__RJlkg","visible":"reveal-on-scroll_visible__ZmFRz"};